<!-- 这里的主题还没有全部同步到最新的 themeItem 组件里面，只是同步了一部分，需要再仔细对一下；同步完之后该文件可以废弃 -->

<template>
  <div class="themeItem_box" :class="mode" v-if="currThemeObj">
    <div class="themeItem_title" v-text="themeItem.analysisItemName"></div>
    <div class="themeItem_main" v-if="themeItem.renderData">
      <!-- graphicsId: 1 -- 近期战绩 -->
      <CANVAS_PIE_RECENTACH
        v-if="themeItem.graphicsId == 1"
        :datas="themeItem.renderData"
      ></CANVAS_PIE_RECENTACH>

      <!-- graphicsId: 2 -- 交锋记录 -->
      <HTML_CONFRRECORD
        v-if="themeItem.graphicsId == 2"
        :datas="themeItem.renderData"
      ></HTML_CONFRRECORD>

      <!-- graphicsId: 3 -- 球员信息 -->
      <HTML_PLAYERINFOR
        v-if="themeItem.graphicsId == 3"
        :datas="themeItem.renderData"
      ></HTML_PLAYERINFOR>

      <!-- graphicsId: 4 -- 球队信息 -->
      <HTML_TEAMINFOR
        v-if="themeItem.graphicsId == 4"
        :datas="themeItem.renderData"
      ></HTML_TEAMINFOR>

      <!-- graphicsId: 5 -- 球员数据对比 -->
      <HTML_BAR_BOTHSIDEPLAYER
        v-if="themeItem.graphicsId == 5"
        :datas="themeItem.renderData"
      ></HTML_BAR_BOTHSIDEPLAYER>

      <!-- graphicsId: 6 -- 球队数据对比 -->
      <!-- <HTML_BAR_BOTHSIDETEAM
          v-if="themeItem.graphicsId == 6"
          :datas="themeItem.renderData"
        ></HTML_BAR_BOTHSIDETEAM> -->
      <HTML_BAR_BOTHSIDEPLAYER
        v-if="themeItem.graphicsId == 6"
        :isPlayer="false"
        :datas="themeItem.renderData"
      ></HTML_BAR_BOTHSIDEPLAYER>

      <!-- graphicsId: 7 -- 主队常用阵容 -->
      <CANVAS_PIE_COMLINEUP
        v-if="themeItem.graphicsId == 7"
        :datas="themeItem.renderData"
      ></CANVAS_PIE_COMLINEUP>

      <!-- graphicsId: 9 -- 客队常用阵容 -->
      <CANVAS_PIE_COMLINEUP
        v-if="themeItem.graphicsId == 9"
        :datas="themeItem.renderData"
      ></CANVAS_PIE_COMLINEUP>

      <!-- graphicsId: 12 -- 比赛 -->
      <html_seasonMatch
        v-if="themeItem.graphicsId == 12"
        :pareData="themeItem.renderData"
        themeClass="broadcastList"
      ></html_seasonMatch>

      <!-- graphicsId: 13 -- 进球 -->
      <html_seasonGoal
        v-if="themeItem.graphicsId == 13"
        :pareData="themeItem.renderData"
        themeClass="broadcastList"
      ></html_seasonGoal>

      <!-- graphicsId: 14 -- 进球时间分布 -->
      <html_seasonGoalTime
        v-if="themeItem.graphicsId == 14"
        :pareData="themeItem.renderData"
        themeClass="broadcastList"
      ></html_seasonGoalTime>

      <!-- graphicsId: 17 -- 射门分布 -->
      <CANVAS_SHOOTINGSTEREOGRAM
        v-if="themeItem.graphicsId == 17"
        :datas="themeItem.renderData"
      ></CANVAS_SHOOTINGSTEREOGRAM>

      <!-- graphicsId:18  -- 进球控球链 -->
      <CANVAS_BALLCONTROLCHAIN
        v-if="themeItem.graphicsId == 18"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
        :tipFontFlag="true"
      ></CANVAS_BALLCONTROLCHAIN>

      <!-- graphicsId: 19 -- 防守区域 -->
      <CANVAS_REGIONALCOVERAGE
        v-if="themeItem.graphicsId == 19"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></CANVAS_REGIONALCOVERAGE>

      <!-- graphicsId: 20 -- 跑区热力图 -->
      <HEATMAP
        v-if="themeItem.graphicsId == 20"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></HEATMAP>

      <!-- graphicsId: 21 -- 数据分析-球员数据对比【雷达图】 -->
      <CANVAS_RADAR_PLAYERSINFOR
        v-if="themeItem.graphicsId == 21"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></CANVAS_RADAR_PLAYERSINFOR>

      <!-- graphicsId: 25 -- 胜率预测 -->
      <WINRATEPREDICTION_BAR
        v-if="themeItem.graphicsId == 25"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></WINRATEPREDICTION_BAR>

      <!-- graphicsId: 27 -- 比赛态势 -->
      <MATCHSTATE_KEYEVENT_BAR
        v-if="themeItem.graphicsId == 27"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></MATCHSTATE_KEYEVENT_BAR>

      <!-- graphicsId: 28 -- 射门分布及期望进球 -->
      <SHOOTDIS_EXPECTEDGOAL_SCATTER
        v-if="themeItem.graphicsId == 28"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></SHOOTDIS_EXPECTEDGOAL_SCATTER>

      <!-- graphicsId: 29 -- 球员平均占位 -->
      <PLAYER_AVERAGEROCCUPANCY_SCATTER
        v-if="themeItem.graphicsId == 29"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></PLAYER_AVERAGEROCCUPANCY_SCATTER>

      <!-- graphicsId: 30 -- 球员信息对比 -->
      <HTML_TEMAPLAYERINFOR_DOUBLE
        v-if="themeItem.graphicsId == 30"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></HTML_TEMAPLAYERINFOR_DOUBLE>

      <!-- graphicsId: 31 -- 球队信息对比 -->
      <HTML_TEMAPLAYERINFOR_DOUBLE
        v-if="themeItem.graphicsId == 31"
        :isPlayer="false"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></HTML_TEMAPLAYERINFOR_DOUBLE>

      <!-- graphicsId: 32 -- 传球风格 -->
      <PASSINGSTYLE_PIE
        v-if="themeItem.graphicsId == 32"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></PASSINGSTYLE_PIE>

      <!-- graphicsId: 33 -- 球队跑区热力图 -->
      <HEATMAP
        v-if="themeItem.graphicsId == 33"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
        :heatWeight="0.35"
      ></HEATMAP>

      <!-- graphicsId: 34 -- 球员跑区热力图 -->
      <HEATMAP
        v-if="themeItem.graphicsId == 34"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
        :heatWeight="0.45"
      ></HEATMAP>

      <!-- graphicsId: 35 -- 数据分析-球队数据对比【雷达图】 -->
      <CANVAS_RADAR_PLAYERSINFOR
        v-if="themeItem.graphicsId == 35"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
        :themeType="'team'"
      ></CANVAS_RADAR_PLAYERSINFOR>

      <SITUATION_MAP
        v-if="themeItem.graphicsId == 41"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
        :heatWeight="0.35"
      ></SITUATION_MAP>

      <HTML_SHOOTANALYSIS
        v-if="themeItem.graphicsId == 42"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></HTML_SHOOTANALYSIS>


      <!-- graphicsId:  -- 反击效率 -->
      <CANVAS_SCATTER_COORDINATSYS
        v-if="themeItem.graphicsId == 101"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></CANVAS_SCATTER_COORDINATSYS>

      <!-- graphicsId:  -- 期望进球 -->
      <CANVAS_GRAPH_EXPECTGOAL
        v-if="themeItem.graphicsId == 102"
        :datas="themeItem.renderData"
        :currThemeObj="currThemeObj"
      ></CANVAS_GRAPH_EXPECTGOAL>
    </div>
  </div>
</template>

<script>
import HTML_PLAYERINFOR from '@components/football/html/HTML_PLAYERINFOR/index.vue'
import HTML_TEAMINFOR from '@components/football/html/HTML_TEAMINFOR/index.vue'
import HTML_TEMAPLAYERINFOR_DOUBLE from '@components/football/html/HTML_TEMAPLAYERINFOR_DOUBLE/index.vue'
import HTML_BAR_BOTHSIDEPLAYER from '@components/football/html/HTML_BAR/AbBothSidePlayerPerformance.vue'
import HTML_CONFRRECORD from '@components/football/html/HTML_CONFRRECORD/index.vue'

// import HTML_BAR_BOTHSIDETEAM from '@components/football/html/HTML_BAR/AbBothSideTeamPerformance.vue'

import CANVAS_SHOOTINGSTEREOGRAM from '@components/football/canvas/shootingStereogram/index.vue'
import CANVAS_REGIONALCOVERAGE from '@components/football/canvas/regionalCoverage/index.vue'
import CANVAS_BALLCONTROLCHAIN from '@components/football/echarts/ballControlChain/index.vue'
import HEATMAP from '@components/football/heatMap/cup_heatMap.vue'
import SITUATION_MAP from '@components/football/SituationMap.vue'
import HTML_SHOOTANALYSIS from '@components/football/html/HTML_SHOOTANALYSIS/index.vue'

import CANVAS_SCATTER_COORDINATSYS from '@components/football/echarts/scatter/coordinateSystemScatter.vue'
import CANVAS_GRAPH_EXPECTGOAL from '@components/football/echarts/graph/expectGoalScatter.vue'
import CANVAS_PIE_RECENTACH from '@components/football/echarts/pie/recentAchievements.vue'
import CANVAS_PIE_COMLINEUP from '@components/football/echarts/pie/commonLineup.vue'
import CANVAS_RADAR_PLAYERSINFOR from '@components/football/echarts/radar/playersInforRadar.vue'

import html_seasonMatch from '@components/football/html/HTML_DATAOVERVIEW/seasonMatch.vue'
import html_seasonGoal from '@components/football/html/HTML_DATAOVERVIEW/seasonGoal.vue'
import html_seasonGoalTime from '@components/football/html/HTML_DATAOVERVIEW/seasonGoalTime.vue'

import MATCHSTATE_KEYEVENT_BAR from '@components/football/echarts/bar/matchState_keyEvent_bar.vue'

import PLAYER_AVERAGEROCCUPANCY_SCATTER from '@components/football/echarts/scatter/player_averageOccupancy_scatter.vue'
import SHOOTDIS_EXPECTEDGOAL_SCATTER from '@components/football/echarts/scatter/shootingDistribution_expectedGoal_scatter.vue'
import WINRATEPREDICTION_BAR from '@components/football/echarts/bar/winRatePrediction_bar.vue'
import PASSINGSTYLE_PIE from '@components/football/echarts/pie/passingStyle_pie.vue'

import cup_cardList from '@components/platfromBase/football/cup_cardList.vue'

import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'cup_themeItem',
  mixins: [cup_base_data_mixin],
  components: {
    HTML_PLAYERINFOR,
    HTML_TEAMINFOR,
    HTML_TEMAPLAYERINFOR_DOUBLE,
    HTML_BAR_BOTHSIDEPLAYER,
    HTML_CONFRRECORD,
    // HTML_BAR_BOTHSIDETEAM,
    CANVAS_SHOOTINGSTEREOGRAM,
    CANVAS_REGIONALCOVERAGE,
    CANVAS_BALLCONTROLCHAIN,
    CANVAS_SCATTER_COORDINATSYS,
    CANVAS_GRAPH_EXPECTGOAL,
    HEATMAP,
    SITUATION_MAP,
    HTML_SHOOTANALYSIS,
    CANVAS_PIE_RECENTACH,
    CANVAS_PIE_COMLINEUP,
    CANVAS_RADAR_PLAYERSINFOR,
    html_seasonMatch,
    html_seasonGoal,
    html_seasonGoalTime,
    MATCHSTATE_KEYEVENT_BAR,
    PLAYER_AVERAGEROCCUPANCY_SCATTER,
    SHOOTDIS_EXPECTEDGOAL_SCATTER,
    WINRATEPREDICTION_BAR,
    PASSINGSTYLE_PIE,
  },
  props: {
    themeItem: {
      type: Object,
      default: null,
    },
    mode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  created() {},
}
</script>

<!-- <style lang="scss" scoped>
.themeItem_box {
  width: 100%;
  height: 24.04vw;
  &.broadcastList {
    .themeItem_title {
      font-size: 0.972vw;
    }
  }
  .themeItem_title {
    width: 100%;
    height: 2.5vw;
    background-image: var(--mixtmt_themeItem_title_bg0);
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    color: var(--mixtmt_whiteColor);
    font-size: 1.11vw;
    text-align: center;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
  }
  .themeItem_main {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 21.54vw;
  }
}
</style> -->
